import {Routes} from '@angular/router';

export const categoryManagementRoutes: Routes = [

      {
        path: 'categoryManagement',
        loadComponent: () => import('./category-management.component').then(m => m.CategoryManagementComponent),
        data: { title: '商城品类上架' },
      }
];
